(function () {
    'use strict';

    angular
        .module('ib-apis-form-module')
        .factory('ApisFormService', ApisFormService);

    ApisFormService.$inject = ['$q', 'localStorageService', 'CallApisFormService', 'ApisFormTransformer', 'GetCKICachedInformationService', 'GetCountriesListService', 'GetStatesListService', 'ModalService', 'GetFrequentFlyersService', 'GetPhoneCodesService', 'UpdateFlightsPassengerInfoService', 'PassengerAdditionalInfoService', 'NewslettersService', 'CkiDatalayerUtilsService', 'CkiDatalayerConstants', 'TravelInfoService', 'UtilsService', '$location', '$window', 'CheckinAppConstants'];
    function ApisFormService ($q, localStorageService, CallApisFormService, ApisFormTransformer, GetCKICachedInformationService, GetCountriesListService, GetStatesListService, ModalService, GetFrequentFlyersService, GetPhoneCodesService, UpdateFlightsPassengerInfoService, PassengerAdditionalInfoService, NewslettersService, CkiDatalayerUtilsService, CkiDatalayerConstants, TravelInfoService, UtilsService, $location, $window, CheckinAppConstants) {
        const service = {
            searchApisInfo: searchApisInfo,
            updateApisInfo: updateApisInfo,
            updatePassengersDataContact: updatePassengersDataContact,
            updateDestinationForAll: updateDestinationForAll,
            updateOriginForAll: updateOriginForAll,
            generateListOfErrorsPassenger: generateListOfErrorsPassenger,
            updateStatusPassengers: updateStatusPassengers,
            deleteTravelInfoDocument: deleteTravelInfoDocument

        };

        return service;

        ////////////////
        function searchApisInfo () {
            var deferred = $q.defer();
            var apisInfo = {}, frequentFlyers = {}, prefixes = [], countries = [], states = [];
            var pasApis = localStorageService.get('passengersAPIS');
            ModalService.isWaiting();
            CallApisFormService.getApisInfo(pasApis).then(getApisSuccess, getApisInfoError);
            return deferred.promise;

            function getApisSuccess (data) {
                apisInfo = data;
                if (localStorageService.get('bookingInfo')) {
                    GetFrequentFlyersService.getFrequentFlyers().then(frequentFlyersSuccess, searchApisInfoError);
                } else {
                    GetCKICachedInformationService.getCachedInformation().then((cached) => {
                        localStorageService.set('bookingInfo', cached);
                        GetFrequentFlyersService.getFrequentFlyers().then(frequentFlyersSuccess, searchApisInfoError);
                    }, searchApisInfoError);
                }
            }


            function getApisInfoError (error) {
                ModalService.isNotWaiting();
                ModalService.showGenericModal({ message: error.message }, false, 'generic-info-modal').result.then(() => {
                    $location.path('/ibcoac');
                });

            }

            function searchApisInfoError (error) {
                ModalService.isNotWaiting();
                if (error.errorCode === -1 || error.errorCode === 500) {
                    ModalService.showGenericModal({ message: error.message }, false, 'generic-info-modal').result.then(() => {
                        $location.path('/ibcose');
                    });
                } else {
                    ModalService.setErrorMessage(error.message);
                    ModalService.setErrorCode(error.internalErrorCode);
                    ModalService.isError(error);
                }
            }

            function frequentFlyersSuccess (data) {
                frequentFlyers = data;
                GetPhoneCodesService.getPhoneCodesList().then(prefixesSuccess, searchApisInfoError);
            }


            function prefixesSuccess (data) {
                var existAPIs = (pasApis !== null && pasApis.length > 0);
                prefixes = data;
                if (existAPIs) {
                    localStorageService.remove('countriesList');
                }
                GetCountriesListService.getCountriesList(null, null, existAPIs).then(countriesSuccess, searchApisInfoError);
            }

            function countriesSuccess (data) {
                countries = data;
                localStorageService.set('countries');
                GetStatesListService.getStatesList('US').then(statesSuccess, searchApisInfoError);
            }

            function statesSuccess (data) {
                states = data;
                if (UtilsService.isUserLogged()) {
                    TravelInfoService.getTravelInfo().then(travelInfoSuccess, searchApisInfoError);
                } else {
                    travelInfoSuccess([]);
                }
            }


            function travelInfoSuccess (data) {
                var transformedApisInfo = ApisFormTransformer.transformApisView(apisInfo, frequentFlyers, countries, prefixes, states, data, localStorageService.get('gdprInfo'));
                localStorageService.set('apisPendingAQQ', ApisFormTransformer.generatePassengerPendingAQQ(localStorageService.get('bookingInfo'), pasApis));
                ModalService.isNotWaiting();
                deferred.resolve(transformedApisInfo);
            }
        }


        /**
         * Modify the state of passenger for show/hidden values in form of data contact
         * @param {Array} passengersData All passengers data for change values
         * @param {Int} passengerId ID of passenger selected
         * @param {String} type Type of option selected in the form
         * @param {Object} Model of page
         */
        function updatePassengersDataContact (passengersData, passengerId, type, showData, model) {
            ApisFormTransformer.updatePassengersDataContact(passengersData, passengerId, type, showData, model);
        }


        /**
         * Delete document of travel
         * @param {Object} document
         */
        function deleteTravelInfoDocument (document, passengers) {
            ApisFormTransformer.updateDocument(document, passengers);
        }
        /**
         * Update the destination model of passengers
         * @param {String} index Index from passenger to copy information
         */
        function updateDestinationForAll (passengers, showInTransitForAll, index) {
            ApisFormTransformer.updateDestinationPassengers(passengers, showInTransitForAll, index);
        }

        /**
         * Update the origin model of passengers
         * @param {String} index Index from passenger to copy information
         */
         function updateOriginForAll (passengers, index) {
            ApisFormTransformer.updateOriginPassengers(passengers, index);
        }


        /**
         * Update the status of the passengers
         * @param {Array} passengers Array of passengers to update
         */
        function updateStatusPassengers (passengers, model) {
            GetCKICachedInformationService.getCachedInformation().then((cachedData) => {
                ApisFormTransformer.updateStatusPassenger(passengers, cachedData.passengers, model);
            }, (error) => {
                ModalService.isNotWaiting();
                ModalService.setErrorMessage(error.message);
                ModalService.setErrorCode(error.internalErrorCode);
                ModalService.isError(error);
            });
        }


        /**
         * Return list of error of passengers recived of service
         * @param {Array} passengers List of passengers
         * @param {Array} errors List of errors of passengers returned of service
         */
        function generateListOfErrorsPassenger (passengers, error) {
            return ApisFormTransformer.generateListErrorPassengers(passengers, error);
        }

        function updateApisInfo (apisModel) {
            var deferredUpdate = $q.defer(), passengersTravelInfo = null;
            const isUserLogged = UtilsService.isUserLogged();

            ModalService.isWaiting();
            if (apisModel !== null) {
                if (isUserLogged) {
                    passengersTravelInfo = ApisFormTransformer.generateCustomerTravelInfo(apisModel.apisPassengerInfo.passengers);
                }
                PassengerAdditionalInfoService.updateAdditionalInfo(ApisFormTransformer.generateAdditionalInformationRequest(apisModel)).then(ok, generalServiceError);
            } else {
                checkPendingAQQStates();
            }
            return deferredUpdate.promise;

            function ok ()  {
                if (!isUserLogged) {
                    updateNewsLetters(ApisFormTransformer.generateNewsLetterInfo(apisModel));
                }

                if (passengersTravelInfo) {
                    TravelInfoService.saveTravelInfo(passengersTravelInfo);
                }
                CallApisFormService.updateApisInfo(ApisFormTransformer.generateUpdateApisRequest(apisModel)).then(updateApisSuccess, (error) => {
                    updateApisError(apisModel.apisPassengerInfo.passengers, error);
                });
            }
            function updateNewsLetters (newslettersInfo) {
                var i;
                if (newslettersInfo && newslettersInfo.length > 0) {
                    for (i = 0; i < newslettersInfo.length; i++) {
                        NewslettersService.putNewsletters(newslettersInfo[i]);
                    }
                }
            }

            function updateApisSuccess () {
                localStorageService.set('nextStepAllowed', false);
                var pasID = localStorageService.get('passengersAPISUpdated') || [], i;
                for (i = 0; i < apisModel.apisPassengerInfo.passengers.length; i++) {
                    if (!apisModel.apisPassengerInfo.passengers[i].basicInfo.isInfant && apisModel.apisPassengerInfo.passengers[i].boardingCard &&
                        pasID.indexOf(parseInt(apisModel.apisPassengerInfo.passengers[i].id)) === -1) {
                        pasID.push(parseInt(apisModel.apisPassengerInfo.passengers[i].id));
                    }
                }
                localStorageService.set('passengersAPISUpdated', pasID);
                checkPendingAQQStates();
            }


            function checkPendingAQQStates () {
                var passengersStatus, needEstaDataMsg = '', i;
                GetCKICachedInformationService.getCachedInformation().then((cachedData) => {
                    localStorageService.set('bookingInfo', cachedData);
                    passengersStatus = ApisFormTransformer.checkUpdatedPassengersStatus();
                    if (passengersStatus.pendingPas.length > 0) {
                        localStorageService.set('passengersAPIS', passengersStatus.pendingPas);
                        ModalService.isNotWaiting();
                        ModalService.openPendingAQQErrorModal({ message: '', internalErrorCode: 'PENDING_AQQ_ERROR_MODAL', errorCode: '' });
                    } else if (passengersStatus.isUncheckable) {
                        for (i = 0; i < cachedData.passengers.length; i++) {
                            if (cachedData.passengers[i].status && cachedData.passengers[i].status.code === CheckinAppConstants.GENERAL_PASSENGERS_STATUS.NOT_ALLOWED) {
                                if (cachedData.passengers[i].status.reason.code &&
                                    cachedData.passengers[i].status.reason.code === CheckinAppConstants.GENERAL_PASSENGERS_STATUS.ESTA_CONSTRAINTS ||
                                    cachedData.passengers[i].status.reason.code === CheckinAppConstants.GENERAL_PASSENGERS_STATUS.AQQ_ESTA_CONSTRAINTS) {
                                    needEstaDataMsg = cachedData.passengers[i].status.reason.message;
                                }
                            }
                        }
                        ModalService.isNotWaiting();
                        ModalService.openApisUncheckableErrorModal({ message: needEstaDataMsg, internalErrorCode: 'APIS_STATUS_UNCHECKABLE', errorCode: '' });
                        localStorageService.remove('passengersAPISUpdated');
                    } else {
                        updatedApisInfo(localStorageService.get('passengersAPISUpdated'));
                    }
                    deferredUpdate.resolve();
                }, generalServiceError);
            }


            function updatedApisInfo (passengersId) {
                localStorageService.remove('passengersAPISUpdated');
                /* INIT DELETE GA4 MIGRATION*/
                const extendedObject = {};
                extendedObject[CkiDatalayerConstants.DATALAYER_INFO.APIS_FULFILLED] = CkiDatalayerConstants.DATALAYER_VALUES.YES;
                CkiDatalayerUtilsService.addDataLayerInfo(extendedObject);
                /* FIN DELETE GA4 MIGRATION*/
                const extendedDigitalDataInfo = {};
                extendedDigitalDataInfo[CkiDatalayerConstants.DIGITAL_DATA_INFO.APIS_COMPLETED] = CkiDatalayerConstants.DATALAYER_VALUES.YES;
                CkiDatalayerUtilsService.addDigitalDataInfo(extendedDigitalDataInfo);

                UpdateFlightsPassengerInfoService.updateApisInformation(passengersId);
            }

            function updateApisError (passengers, error) {
                var response;
                ModalService.isNotWaiting();
                if (error.errorCode === 409) {
                    response = { errorCode: error.errorCode, passengers: error.data };
                    generateListOfErrorsPassenger(passengers, error.data);
                    deferredUpdate.reject(response);
                } else {
                    ModalService.setErrorMessage(error.message);
                    ModalService.setErrorCode(error.internalErrorCode);
                    ModalService.isError(error);
                    deferredUpdate.reject();
                }
            }

            function generalServiceError (error) {
                ModalService.isNotWaiting();
                ModalService.setErrorMessage(error.message);
                ModalService.setErrorCode(error.internalErrorCode);
                ModalService.isError(error);
                deferredUpdate.reject(error);
            }
        }
    }
})();
